import { forwardRef, useImperativeHandle, useRef } from 'react';
import { OrbitControls, View as ViewImpl } from '@react-three/drei';
import { r3f } from './global';

export const Three = ({ children }) => {
    return <r3f.In>{children}</r3f.In>;
};

const TowerEffectView = forwardRef(({ children, orbit, ...props }, ref) => {
    const localRef = useRef(null);
    useImperativeHandle(ref, () => localRef.current);

    return (
        <>
            <div ref={localRef} {...props} />
            <Three>
                <ViewImpl track={localRef}>
                    {children}
                    {orbit && <OrbitControls enableRotate={false} enablePan={false} enableZoom={false} makeDefault />}
                </ViewImpl>
            </Three>
        </>
    );
});

TowerEffectView.displayName = 'TowerEffectView';

export { TowerEffectView };
